"use client";

import { useEffect, useState} from "react";
import "./ThemeChange.css";
import { MdLightMode, MdDarkMode } from "react-icons/md";

export default function ThemeChange({ id = "theme-toggle" }) {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }

    return localStorage.getItem("theme") === "dark";
  });

  useEffect(() => {
    document.body.classList.toggle("dark-mode", isDarkMode);
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  const toggleDarkMode = (event) => {
    const nowDark = event.target.checked;
    setIsDarkMode(nowDark);
  };

  return (
    <label className="themeToggle" htmlFor={id}>
      <span className="themeToggleIcons">{isDarkMode ? <MdDarkMode /> : <MdLightMode />}</span>
      <span className="switchTrack">
        <input
          id={id}
          type="checkbox"
          checked={isDarkMode}
          onChange={toggleDarkMode}
          aria-label="Toggle theme mode"
        />
        <span className="switchSlider" />
      </span>
    </label>
  );
}
